import React from 'react';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

import { Tooltip } from 'ui-components/components/tooltip';

import style from './cost-review-line-item-duties.module.css';
import { messages } from './messages';
import { FormattedCurrencyContainer } from '../../../components/formatted-currency/container';
import { CostReviewLine } from '../cost-review-line-item-service/cost-review-line';

/**
 * @param {object} props
 * @param {number} [props.value] - Amount to display in cost review
 * @param {string} [props.currencyCode] - Currency code to display in cost review
 * @param {boolean} [props.isWalleted] - Is walleted carrier integration or not
 * @returns {React.JSX.Element}
 */
export const CostReviewLineItemDuties = ({ value, currencyCode, isWalleted }) => {
  const labelMessage = isWalleted ? messages.dutiesAndTaxesGuaranteed : messages.dutiesAndTaxesEstimated;
  const tooltipMessage = isWalleted ? messages.dutiesAndTaxesWalletedTooltip : messages.dutiesAndTaxesNonWalletedTooltip;

  if (value === null || value === undefined) {
    return null;
  }

  return (
    <CostReviewLine>
      <div>
        <label className={style['duty-label']}>
          <FormattedMessage {...labelMessage} />
        </label>
        <Tooltip position='top' text={<FormattedMessage {...tooltipMessage} />}>
          <span className={style['tooltip-wrapper']}>
            <FontAwesomeIcon className={style['tooltip-icon']} icon={faInfoCircle} />
          </span>
        </Tooltip>
      </div>
      <FormattedCurrencyContainer currencyCode={currencyCode} value={value} />
    </CostReviewLine>
  );
};
